import { gql } from "@apollo/client";
import { cerrarSesionArchivos } from "services/fileSession";

export const login = gql`
  mutation login($userInput: UserInput!, $latitud: Float, $longitud: Float, $accuracy: Float) {
    login(input: $userInput, latitud: $latitud, longitud: $longitud, accuracy: $accuracy) {
      token
      requiereCambioPassword
      cambioToken
      emailEnmascarado
      user {
        id
        username
        nombre
        tipoUser
        tempPassword
        permisos {
          id
          nombre
          pantalla
        }
      }
    }
  }
`;

export const GET_USER = gql`
  query getUser {
    currentUser {
      id
      tipoUser
      username
      nombre
      apellido
      email
      telefono
      permisos {
        id
        nombre
        pantalla
      }
      empresa {
        nombre
        cuit
        file
        direccion
        telefono
      }
      convenio {
        tipoUsuario
      }
      sede {
        id
        nombre
      }
    }
  }
`;

export const logout = () => {
  localStorage.removeItem("user");
  sessionStorage.removeItem("user");
  cerrarSesionArchivos();
  window.location.href = "/login";
};
